module.exports = __webpack_public_path__ + "static/img/unit-2.a5a3385.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/unit-2.png
// module id = +Tt3
// module chunks = 52